var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-change-date"},[(false)?_c('span',[_vm._v("\n    Verändert am "+_vm._s(_vm.timestamp)+"\n  ")]):_vm._e(),(false)?_c('span',[_vm._v("\n    15. März 2019 von Name\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }